import { STRING } from 'resources'
import { validatePhoneNumber } from 'utils/phone-number'
import { validateEmail } from 'utils/email'

export const validateUsername = (username, region) => {
  if (validateEmail(username)) {
    return { isValid: true, isEmail: true, isPhoneNumber: false }
  }
  if (validatePhoneNumber(username, region)) {
    return { isValid: true, isEmail: false, isPhoneNumber: true }
  }
  return { isValid: false, isEmail: null, isPhoneNumber: null }
}

export const composeCognitoError = (cognitoError, resendMethod = null) => {
  if (!cognitoError) {
    return ''
  }
  if (/User not found/.test(cognitoError)) {
    return STRING.signInPage.cognitoErrorUserNotFound
  }
  if (/Failed to confirm sign in/.test(cognitoError)) {
    return STRING.signInCodeVerification.cognitoErrorFailedToConfirmSignIn
  }
  if (resendMethod && /Internal error/.test(cognitoError)) {
    return STRING.signInCodeVerification.cognitoErrorInternalError[resendMethod]
  }
  if (/invocation failed due to error/.test(cognitoError)) {
    return STRING.signInPage.cognitoErrorDefault
  }
  const matches = cognitoError.match(/^UserMigration failed with error "(.*?)".$/)
  return matches?.[1] || STRING.signInPage.cognitoErrorDefault
}
